import { useContext } from "react";
import { Context } from "./Context";
import { TpGlobalState } from "./useGlobalState";

export function useStore(): TpGlobalState {
  const store = useContext(Context);
  return store;
}
